import localJson from '../../Assets/Json/adeo_poubelle.json';
import viewerJson from '../../Assets/Json/adeo_verre.json';

export const SAVING = true;
export const LOCAL_JSON = localJson;
export const LOCAL_VIEWER_JSON = viewerJson;
